import * as React from 'react';
import { useContext } from 'react';
import classNames from 'classnames';
import moment from 'moment';

import '@/lib/string';
import { AccountLink } from '@/lib/navigation';
import type { EventElementProps } from './event-element-props.interface';
import { EventInfoContext } from './event-info';

export const SmsMessage = ({ data }: EventElementProps) => {
  const { updateError } = useContext(EventInfoContext);
  return (
    <div
      id={`SmsMessage-${data.id}`}
      className={`message-box ${data.direction}`}
      data-status={data.status}
      data-direction={data.direction}
      title={`${data.segments} sms ${data.segments === 1 ? 'segment' : 'segments'}`}
    >
      {data.direction === 'in' && (
        <div className="inbound-message">
          <div
            className="message-text"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={data.message_html.toReactHtml({ linkify: true })}
          />
        </div>
      )}
      {data.direction === 'out' && (
        data.content_type && data.content_type !== 'text/plain'
          ? (
            <div className="outbound-message">
              <div
                className="message-text"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={data.message_html.toReactHtml({ linkify: true })}
              />
            </div>
          ) : (
            <div className="outbound-message">
              <div
                className={classNames(
                  'message-text',
                  { 'large-text': data.content_type && data.content_type !== 'text/plain' && data.pure_emoji_message },
                )}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={data.message_html.toReactHtml({ linkify: true })}
              />
            </div>
          )
      )}
      <div className={`chat-timestamp stamp-${data.direction}`}>
        <span className="chat-timestamp-sender">
          {data.sender_tag}
        </span>
        {data.broadcast_id && (
          <AccountLink path={`broadcasts/${data.broadcast_id}`}>
            <span className="chat-timestamp-origin account-link">
              {` - via Broadcast ${data.broadcast_name?.substring(0, 30) ?? ''}`}
            </span>
          </AccountLink>
        )}
        {data.origin === 'website-widget' && (
          <AccountLink path="/widgets">
            <span className="chat-timestamp-origin account-link">
              {' - triggered by Widget'}
            </span>
          </AccountLink>
        )}
        {data.segments > 1 && (
          <span className="chat-timestamp-segments">
            {` - ${data.segments} sms segments`}
          </span>
        )}
        {data.sent_at && (
          <span className="chat-timestamp-timestamp">
            {` - ${moment(data.sent_at * 1000).format('L [AT] LT')}`}
          </span>
        )}
        <span className={classNames('chat-read-receipt', data.read_receipt)} />
        <span onClick={() => data.error_description && updateError(data.error_description)} style={{ cursor: 'pointer' }} className={classNames('chat-timestamp-error', { 'info-hover': !!data.error_description })}>
          {data.sanitized_error_text}
        </span>
      </div>
    </div>
  )
};
